import React, { useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

const menus = [
  { title: "All Tables", to: "/all-tables" },
  { title: "Take Away", to: "/take-away" },
  { title: "Customer Search", to: "/customer-search" },
  { title: "Waiters", to: "/waiters" },
];

const TopMenu = () => {
  const navigate = useNavigate();
  const [menuIdx, setMenuIdx] = useState(0);
  const handleMenu = (idx, to) => {
    setMenuIdx(idx);
    navigate(to);
  };
  return (
    <div
      style={{
        width: 1077,
        background: "#FFFFFF",
        height: 91,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: `0px 3px 8px rgba(0, 0, 0, 0.1)`,
        marginLeft: 2,
      }}
    >
      <div style={{ width: 1017 }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {menus.map((item, index) => (
            <MenuItem
              item={item}
              idx={index}
              key={index}
              handleMenu={handleMenu}
              menuIdx={menuIdx}
            />
          ))}
        </Grid>
      </div>
    </div>
  );
};

const MenuItem = ({ item, idx, handleMenu, menuIdx }) => (
  <div
    style={{
      fontSize: 16,
      fontWeight: "400",
      fontFamily: `Roboto, sans-serif`,
      width: 233,
      height: 48,
      border: `${idx == menuIdx ? "1px solid #ED1B24" : "1px solid #A5A5A5"}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: `${idx == menuIdx ? "#ED1B24" : "#FFFFFF"}`,
      color: `${idx == menuIdx ? "#FFFFFF" : "#37465B"}`,
      cursor: "pointer",
    }}
    onClick={() => handleMenu(idx, item.to)}
  >
    {item.title}
  </div>
);

export default TopMenu;
